import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={20} cy={20} r={20} fill="#000" fillOpacity={0.02} />
      <G clipPath="url(#clip0_169_16895)">
        <Path
          d="M26.712 22.507a9.235 9.235 0 00-2.07-.607c-.355-.227-.23-.629-.255-.815.194-.116.38-.25.558-.407a3.142 3.142 0 001.03-2.03.864.864 0 00.768-.863l-.002-1.177a.862.862 0 00-.03-.225.87.87 0 00.043-.273v-1.626a2.777 2.777 0 00-2.773-2.774h-2.868a2.777 2.777 0 00-2.774 2.774v1.626c0 .13.03.257.084.37a1.096 1.096 0 00-.073.391v.712a1.1 1.1 0 001.009 1.093 3.141 3.141 0 001.347 2.255c-.033.303.117.731-.253.97a9.233 9.233 0 00-2.071.606 5.308 5.308 0 00-3.226 4.895c0 .387.315.702.703.702h13.376a.703.703 0 00.702-.702 5.308 5.308 0 00-3.225-4.895zm-7.746-8.023a2.15 2.15 0 012.147-2.148h2.868a2.15 2.15 0 012.147 2.148v1.626c0 .105-.067.199-.167.234l-.606.21c-.003.002-.006.003-.01 0-.006-.005-.006-.008-.006-.011l.001-1.146a1.318 1.318 0 00-1.305-1.328c-.015 0-.28-.013-.604.091-.174.056-.624.108-.884.129-1.059-.086-.953-.22-1.477-.22h-.012c-.722.003-1.308.599-1.305 1.327l.002 1.147c0 .003 0 .006-.005.01-.006.004-.009.003-.012.002l-.606-.211a.248.248 0 01-.166-.235v-1.625zm.998 3.875a.313.313 0 00-.313-.306s0 0 0 0h-.202s0 0 0 0a.472.472 0 01-.472-.47v-.63l.555.193a.64.64 0 00.85-.604l-.002-1.147a.691.691 0 01.681-.7c.01.001.191-.008.41.062.279.09 1.014.165 1.1.158.075-.005.744-.059 1.052-.158.213-.069.404-.061.41-.062a.692.692 0 01.68.7v1.147a.64.64 0 00.848.604l.554-.192.002.833c0 .132-.104.24-.232.24h-.206a.313.313 0 00-.312.309c-.012.733-.317 1.415-.836 1.871a2.826 2.826 0 01-1.855.731 2.816 2.816 0 01-1.86-.715c-.523-.451-.833-1.131-.852-1.864zm2.711 3.206h.008a3.437 3.437 0 001.078-.187c.005.029-.044.445.287.828a2.51 2.51 0 01-1.501.495 2.51 2.51 0 01-1.501-.495c.354-.409.276-.85.287-.92.419.182.868.276 1.342.279zm6.56 5.913h-2.25v-1.003a.313.313 0 10-.627 0v1.003h-7.622v-1.003a.313.313 0 10-.627 0v1.003h-2.25a.076.076 0 01-.076-.076 4.682 4.682 0 012.844-4.319c.8-.34 1.531-.494 1.83-.548a3.134 3.134 0 002.09.792c.776 0 1.512-.28 2.09-.792a8.82 8.82 0 011.83.548 4.682 4.682 0 012.844 4.319.076.076 0 01-.076.076z"
          fill="#000"
          stroke="#000"
          strokeWidth={0.4}
        />
      </G>
      <Circle
        cx={14}
        cy={22}
        r={5.25}
        fill="#FF2E00"
        stroke="#FAFAFA"
        strokeWidth={1.5}
      />
      <Path
        d="M14.028 23.559c-.264 0-.477-.172-.502-.436-.032-.305-.045-.616-.06-.921-.045-.737-.093-1.472-.13-2.209-.017-.305.088-.56.361-.721a.678.678 0 011.014.52c.029.319-.019.633-.035.948-.038.756-.101 1.513-.12 2.27-.016.326-.226.549-.528.549zM14.69 24.744a.678.678 0 01-.68.664.692.692 0 01-.676-.686.695.695 0 01.696-.684c.375.003.664.312.66.706z"
        fill="#fff"
      />
      <Defs>
        <ClipPath id="clip0_169_16895">
          <Path fill="#fff" transform="translate(14 11)" d="M0 0H17V17H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
